import { createSlice } from "@reduxjs/toolkit";

const initialState ={
    modalShow : false,
    modalModifShow : false,
    list :[],
    ajoutOk : false,
    modifOk : false,
    current :[],
}
const Clients = createSlice({
    name : 'ClientsData',
    initialState,
    reducers :{
        showmodal:(state,action) =>{
            state.modalShow=action.payload
        },
        getList:(state,action) =>{
            state.list=action.payload
        },
        current:(state,action) =>{
            state.current=action.payload
        },
        ajout:(state,action) =>{
            state.ajoutOk=action.payload
    },
        modif:(state,action) =>{
        state.modifOk=action.payload
},
        addOne:(state,action) =>{
            state.list.push(action.payload)
    },
        modalModifShow:(state,action) =>{
            state.modalModifShow=action.payload
},
    update: (state, action) => {

        const element = state.list.find(element => element._id === action.payload.idclient);
        if (element) {
            element.designation = action.payload.designation;
            element.contact = action.payload.contact;
            element.tel = action.payload.tel;
            element.ice = action.payload.ice;
            element.ville = action.payload.ville;
            element.rib = action.payload.rib;

    }
  },
  remove: (state, action) => {    
    const id = action.payload;
    state.list=state.list.filter(element => element._id !== id);
  }

    }
})

export const {showmodal,getList,ajout,modif,addOne,modalModifShow,update,current,remove} = Clients.actions
export default Clients.reducer;